module.exports = __webpack_public_path__ + "static/media/cpm-ireland.d39d041c.jpg";